import { useState } from 'react'
import { Dialog } from './Dialog'

/**
 * FED-53 / CMP-8 (David, 10 Oct): "less text — put the details behind a ? or
 * show help". The hub had no help pattern, so this is it: a small ? button
 * beside the one short line that stays on screen, opening the explanation in
 * the ordinary <Dialog> (trap, Escape, focus return — nothing re-implemented).
 *
 * The button's accessible name is the dialog's title, so a screen reader hears
 * "About your photos, button" rather than "question mark". Use it where a
 * paragraph of rules used to sit in the flow of a form or a page.
 */
export function HelpButton({
  title,
  label,
  children,
  className = '',
}: {
  /** Names the dialog and the button. */
  title: string
  /** Visible text beside the ?, e.g. "How this works". Omit for the ? alone. */
  label?: string
  children: React.ReactNode
  className?: string
}) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <button
        type="button"
        className={`helpbtn${label ? ' helpbtn--label' : ''} ${className}`.trim()}
        aria-label={label ? undefined : title}
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        <span className="helpbtn__q" aria-hidden="true">?</span>
        {label && <span className="helpbtn__text">{label}</span>}
      </button>
      <Dialog open={open} title={title} onClose={() => setOpen(false)} className="helpdialog">
        <div className="helpdialog__body">{children}</div>
      </Dialog>
    </>
  )
}
